/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';
import noop from 'lodash/noop';

import { Block, ErrorMessage } from '@atoms';
import { SlugField, TextField, LocaleSelect, InfoItem, SortableArrayField } from '@molecules';
import RichTextField from '@molecules/RichTextField';
import { NO_MARGIN_BOTTOM } from '@constants';
import ROUTES from '@constants/routes';

import Form from '../Form';

import { FORM_FIELD, FORM_FIELDS } from './constants';

const BookForm = ({ initialValues = {}, error, form, bookId, locale, onSaveDraft, onPublish }) => (
  <>
    <Form form={form} hideRequiredMark layout="vertical" wrapperCol={{ span: 24 }} initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <Block spaced>
        <LocaleSelect
          locale={locale}
          disabled={!bookId}
          route={`${ROUTES.BOOKS}/:id/:locale`}
          needsSave={form.isFieldsTouched}
          onSaveDraft={onSaveDraft}
          onPublish={onPublish}
        />
        <TextField {...FORM_FIELD.TITLE} />
        <SlugField
          {...FORM_FIELD.SLUG}
          generateSlugFrom={!initialValues[FORM_FIELD.SLUG.name] && FORM_FIELD.TITLE.name}
        />
        <RichTextField {...FORM_FIELD.TEXT} />
        <TextField multiline {...FORM_FIELD.SEO_DESCRIPTION} style={NO_MARGIN_BOTTOM} />
      </Block>
      {/* Stupid hack to make antd form properly update form */}
      <Form.List noStyle name={FORM_FIELD.CHAPTERS.name}>
        {noop}
      </Form.List>
      {form.getFieldValue(FORM_FIELD.CHAPTERS.name)?.length > 0 && (
        <Block>
          <SortableArrayField {...FORM_FIELD.CHAPTERS}>
            {(chapter) => (
              <InfoItem>
                <a href={`${ROUTES.CHAPTERS}/${chapter.id}`} rel="noopener noreferrer" style={{ color: '#b3b3b3' }}>
                  {chapter.title}
                </a>
              </InfoItem>
            )}
          </SortableArrayField>
        </Block>
      )}
    </Form>
  </>
);

BookForm.useForm = () => Form.useForm(FORM_FIELDS);

export default BookForm;
